export default "https://cdn-static.gokick.com/assets/ea2c661fec3366c14365f7d1c68d2a3d0c715dc9/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";